import { KybMonitoringSectionCode } from "@/core/kyb/entities/KybMonitoring";

// Chemins relatifs à la base `/api/v1` du client HTTP (comme `kybAccessRecertificationEndpoints`).
const base = "/compliance/kyb/monitoring";

/** Chemin d'une section par branchement explicite (pas d'accès `objet[clé]`). */
function sectionPath(section: KybMonitoringSectionCode): string {
  switch (section) {
    case "UBO":
      return `${base}/ubo`;
    case "EDD":
      return `${base}/edd`;
    case "CORPORATE_ACCESS":
      return `${base}/corporate-access`;
  }
}

const kybMonitoringEndpoints = {
  section: sectionPath,
  cases: (indicator: string, limit: number, offset: number) =>
    base + "/indicators/" + encodeURIComponent(indicator) + "/cases?limit=" + limit + "&offset=" + offset,
};

export default kybMonitoringEndpoints;
